import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FP121 {
  fp121_01: string;
  fp121_02: number;
  fp121_111: number;
  fp121_112: number;
  fp121_113: number;
  fp121_12: number;
  fp121_131: number;
  fp121_132: number;
  fp121_133: number;
  fp121_134: number;
  fp121_14: number;
  fp121_15: number;
  fp121_16: number;
  fp121_17: number;
  fp121_18: number;
  fp121_19: string;
  fp121_20: number;
  fp121_21: string;
  fp121_22: string;
  fp121_23: string;
  fp121_24: string;
  fp121_25: number;
  fp121_26: boolean;
  fp121_27: number;
  fp121_28: string;
  fp121_29: number;
  fp121_30: string;
  fp121_241: string;
  fp121_141: number;
  fp121_151: number;
  fp121_142: number;
  fp121_152: number;
  fp121_31: string;
  fp121_32: string;
  fp121_33: string;
  fp121_34: string;
  fp121_91: string;
  fp121_92: string | null;
  fp121_93: string;
}

export interface FP122 {
  fp122_01: string;
  fp122_02: number;
  fp122_03: number;
  fp122_11: number;
  fp122_12: number;
  fp122_13: string;
  fp122_14: number;
  fp122_15: string;
  fp122_16: number;
  fp122_91: string;
  fp122_92: string | null;
  fp122_93: string;
}

export interface FP123 {
  fp123_01: string;
  fp123_02: number;
  fp123_03: number;
  fp123_10: string;
  fp123_11: string;
  fp123_111: string;
  fp123_112: string;
  fp123_13: number;
  fp123_14: number;
  fp123_15: number;
  fp123_16: string;
  fp123_17: number;
  fp123_18: number;
  fp123_19: string;
  fp123_20: boolean;
  fp123_91: string;
  fp123_92: string | null;
  fp123_93: string;
}

export interface FP120 {
  fp120_01: string;
  fp120_10: string;
  fp120_11: string | null;
  fp120_12: string;
  fp120_131: string;
  fp120_132: string;
  fp120_14: string;
  fp120_15: number;
  fp120_151: number;
  fp120_16: number;
  fp120_161: number;
  fp120_17: number;
  fp120_18: number;
  fp120_19: string;
  fp120_20: boolean;
  fp120_21: string;
  fp120_22: number;
  fp120_23: number;
  fp120_24: string;
  fp120_25: string;
  fp120_26: string | null;
  fp120_27: string | null;
  fp120_28: number;
  fp120_29: string | null;
  fp120_30: boolean;
  fp120_31: number;
  fp120_80: string;
  fp120_91: string;
  fp120_92: string | null;
  fp120_93: string;
  judgments?: FP121[];
  defects?: FP122[];
  basic_infos?: FP123[];
}

export interface ListResponse {
  data: FP120[];
  total: number;
  page: number;
  page_size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface CreateRequest {
  master: FP120;
  judgments: FP121[];
  defects: FP122[];
  basic_infos: FP123[];
}

// ============================================================
// API Functions
// ============================================================

export const pwp211Api = {
  async list(page = 1, pageSize = 20): Promise<ListResponse> {
    const res = await apiClient.get('/api/pwp211', { params: { page, page_size: pageSize } });
    return res.data;
  },

  async get(id: string): Promise<FP120> {
    const res = await apiClient.get(`/api/pwp211/${encodeURIComponent(id)}`);
    return res.data;
  },

  async previewFromSource(sourceNo: string): Promise<FP120> {
    const res = await apiClient.get(`/api/pwp211/source/${encodeURIComponent(sourceNo.trim())}`);
    return res.data;
  },

  async create(req: CreateRequest): Promise<FP120> {
    const res = await apiClient.post('/api/pwp211', req);
    return res.data;
  },

  async update(id: string, req: CreateRequest): Promise<FP120> {
    const res = await apiClient.put(`/api/pwp211/${encodeURIComponent(id)}`, req);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pwp211/${encodeURIComponent(id)}`);
  },
};

export default pwp211Api;
